import { Helmet } from 'react-helmet-async';
import TrafficAnalysis from 'src/sections/overview/dashboards/views/trafficAnalysis';

export default function SearchPerformanceFunnel() {
  return (
    <>
      <Helmet>
        <title>Funnel</title>
      </Helmet>

      <TrafficAnalysis />
    </>
  );
}
